<!-- <div class="container flex align-items-center">
  <p class="flex-grow-1">{{ title }}</p>
  <div class="justify-content-end align-items-center">
    <p-button label="SELECIONAR" [outlined]="true" severity="secondary"></p-button> -->
<!-- <button [ngClass]="contabilidadeSelecionada == 'pessoa-juridica'? 'button-selected' : '' "
      (click)="selecionarContabilidade('pessoa-juridica')"
      class="button flex justify-content-center align-items-center w-8rem h-2rem border-round-md">
    <span *ngIf="contabilidadeSelecionada == 'pessoa-juridica'; else selecionar">
        Selecionado
    </span>

    <ng-template #selecionar>
        Selecionar
    </ng-template>
</button> -->
<!-- </div>
</div> -->

<div class="container flex align-items-center">
  <p class="flex-grow-1">{{ title }}</p>
  <div class="justify-content-end align-items-center">
    <p-button
      [outlined]="true"
      severity="secondary"
      [ngClass]="{ 'button-selected': selected }"
      (click)="onSelect()"
      class=" flex justify-content-center align-items-center w-12rem "
    >
      <span *ngIf="selected; else notSelected"> SELECIONADO </span>
      <ng-template #notSelected> SELECIONAR </ng-template>
    </p-button>
  </div>
</div>
